/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkCreateTeamDto } from '../models/work-create-team-dto';
import { WorkDropdownOptionDto } from '../models/work-dropdown-option-dto';
import { WorkPaginatedDocumented } from '../models/work-paginated-documented';
import { WorkSuccessDto } from '../models/work-success-dto';
import { WorkTeam } from '../models/work-team';
import { WorkUpdateTeamDto } from '../models/work-update-team-dto';

@Injectable({ providedIn: 'root' })
export class WorkTeamsV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `teamsV2ControllerGetAllDropdownOptions()` */
  static readonly TeamsV2ControllerGetAllDropdownOptionsPath = '/v2/teams/dropdown-options';

  /**
   * Required permissions: teams:read, teams:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `teamsV2ControllerGetAllDropdownOptions()` instead.
   *
   * This method doesn't expect any request body.
   */
  teamsV2ControllerGetAllDropdownOptions$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkDropdownOptionDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTeamsV2Service.TeamsV2ControllerGetAllDropdownOptionsPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkDropdownOptionDto>>;
      })
    );
  }

  /**
   * Required permissions: teams:read, teams:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `teamsV2ControllerGetAllDropdownOptions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  teamsV2ControllerGetAllDropdownOptions(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<WorkDropdownOptionDto>> {
    return this.teamsV2ControllerGetAllDropdownOptions$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkDropdownOptionDto>>): Array<WorkDropdownOptionDto> => r.body)
    );
  }

  /** Path part for operation `teamsV2ControllerFindAllPaginated()` */
  static readonly TeamsV2ControllerFindAllPaginatedPath = '/v2/teams';

  /**
   * Required permissions: teams:read, teams:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `teamsV2ControllerFindAllPaginated()` instead.
   *
   * This method doesn't expect any request body.
   */
  teamsV2ControllerFindAllPaginated$Response(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 25
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by active query param.
     *           <p>
     *              <b>Format: </b> filter.active={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.active=$not:$like:John Doe&filter.active=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.active'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> name:ASC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>name</li>
     * <li>shortname</li>
     * <li>roletypeName</li>
     * <li>active</li>
     * <li>montageplanType</li>
     * <li>businessdivisionId</li></ul>
     */
      sortBy?: Array<'name:ASC' | 'name:DESC' | 'shortname:ASC' | 'shortname:DESC' | 'roletypeName:ASC' | 'roletypeName:DESC' | 'active:ASC' | 'active:DESC' | 'montageplanType:ASC' | 'montageplanType:DESC' | 'businessdivisionId:ASC' | 'businessdivisionId:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> name,shortname
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>name</li>
     * <li>shortname</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkTeam>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'active'?: (string | Array<string>);
};
};
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTeamsV2Service.TeamsV2ControllerFindAllPaginatedPath, 'get');
    if (params) {
      rb.query('page', params.page, {});
      rb.query('limit', params.limit, {});
      rb.query('filter.active', params['filter.active'], {});
      rb.query('sortBy', params.sortBy, {});
      rb.query('search', params.search, {});
      rb.query('searchBy', params.searchBy, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPaginatedDocumented & {
        'data'?: Array<WorkTeam>;
        'meta'?: {
        'select'?: Array<string>;
        'filter'?: {
        'active'?: (string | Array<string>);
        };
        };
        }>;
      })
    );
  }

  /**
   * Required permissions: teams:read, teams:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `teamsV2ControllerFindAllPaginated$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  teamsV2ControllerFindAllPaginated(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 25
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by active query param.
     *           <p>
     *              <b>Format: </b> filter.active={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.active=$not:$like:John Doe&filter.active=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.active'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> name:ASC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>name</li>
     * <li>shortname</li>
     * <li>roletypeName</li>
     * <li>active</li>
     * <li>montageplanType</li>
     * <li>businessdivisionId</li></ul>
     */
      sortBy?: Array<'name:ASC' | 'name:DESC' | 'shortname:ASC' | 'shortname:DESC' | 'roletypeName:ASC' | 'roletypeName:DESC' | 'active:ASC' | 'active:DESC' | 'montageplanType:ASC' | 'montageplanType:DESC' | 'businessdivisionId:ASC' | 'businessdivisionId:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> name,shortname
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>name</li>
     * <li>shortname</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<WorkPaginatedDocumented & {
'data'?: Array<WorkTeam>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'active'?: (string | Array<string>);
};
};
}> {
    return this.teamsV2ControllerFindAllPaginated$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkTeam>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'active'?: (string | Array<string>);
};
};
}>): WorkPaginatedDocumented & {
'data'?: Array<WorkTeam>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'active'?: (string | Array<string>);
};
};
} => r.body)
    );
  }

  /** Path part for operation `teamsV2ControllerCreate()` */
  static readonly TeamsV2ControllerCreatePath = '/v2/teams';

  /**
   * Required permissions: teams:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `teamsV2ControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  teamsV2ControllerCreate$Response(
    params: {
      body: WorkCreateTeamDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTeam>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTeamsV2Service.TeamsV2ControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTeam>;
      })
    );
  }

  /**
   * Required permissions: teams:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `teamsV2ControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  teamsV2ControllerCreate(
    params: {
      body: WorkCreateTeamDto
    },
    context?: HttpContext
  ): Observable<WorkTeam> {
    return this.teamsV2ControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTeam>): WorkTeam => r.body)
    );
  }

  /** Path part for operation `teamsV2ControllerFindOneById()` */
  static readonly TeamsV2ControllerFindOneByIdPath = '/v2/teams/{id}';

  /**
   * Required permissions: teams:read, teams:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `teamsV2ControllerFindOneById()` instead.
   *
   * This method doesn't expect any request body.
   */
  teamsV2ControllerFindOneById$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTeam>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTeamsV2Service.TeamsV2ControllerFindOneByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTeam>;
      })
    );
  }

  /**
   * Required permissions: teams:read, teams:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `teamsV2ControllerFindOneById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  teamsV2ControllerFindOneById(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkTeam> {
    return this.teamsV2ControllerFindOneById$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTeam>): WorkTeam => r.body)
    );
  }

  /** Path part for operation `teamsV2ControllerDelete()` */
  static readonly TeamsV2ControllerDeletePath = '/v2/teams/{id}';

  /**
   * Required permissions: teams:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `teamsV2ControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  teamsV2ControllerDelete$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkSuccessDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTeamsV2Service.TeamsV2ControllerDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkSuccessDto>;
      })
    );
  }

  /**
   * Required permissions: teams:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `teamsV2ControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  teamsV2ControllerDelete(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkSuccessDto> {
    return this.teamsV2ControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkSuccessDto>): WorkSuccessDto => r.body)
    );
  }

  /** Path part for operation `teamsV2ControllerUpdate()` */
  static readonly TeamsV2ControllerUpdatePath = '/v2/teams/{id}';

  /**
   * Required permissions: teams:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `teamsV2ControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  teamsV2ControllerUpdate$Response(
    params: {
      id: number;
      body: WorkUpdateTeamDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTeam>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTeamsV2Service.TeamsV2ControllerUpdatePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTeam>;
      })
    );
  }

  /**
   * Required permissions: teams:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `teamsV2ControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  teamsV2ControllerUpdate(
    params: {
      id: number;
      body: WorkUpdateTeamDto
    },
    context?: HttpContext
  ): Observable<WorkTeam> {
    return this.teamsV2ControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTeam>): WorkTeam => r.body)
    );
  }

}
